<template
  :routePreventDialog="routePreventDialog"
  :customClass="'leave-update'"
>
  <div v-if="drawer">
    <v-navigation-drawer
      v-model="drawer"
      fixed
      width="600"
      right
      temporary
      stateless
      style="z-index: 99"
    >
      <v-card text elevation="0" class="d-flex flex-column h-100 custom-field">
        <v-card-title
          class="dialog-custom-header border-bottom white-background px-4 py-2"
        >
          <div class="d-flex align-center justify-space-between width-100">
            <div class="d-flex align-center">
              <v-avatar color="cyan lighten-5" size="40" rounded class="mr-3">
                <v-icon color="cyan darken-2" medium>mdi-calendar-plus</v-icon>
              </v-avatar>
              <div>
                <h3 class="font-weight-700 font-size-20 m-0 color-custom-blue">
                  <template v-if="leaveCreate.id > 0">Update Leave</template>
                  <template v-else>Create Leave</template>
                </h3>
                <p class="font-size-12 grey--text text--darken-1 m-0">
                  Manage staff leave allocations, dates, and documentation
                </p>
              </div>
            </div>
            <v-btn icon v-on:click="$emit('close')">
              <v-icon color="grey darken-1">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="flex-grow-1 px-4 py-3">
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll custom-box-top-inner-shado"
            style="height: calc(100vh - 140px); position: relative"
          >
            <v-form
              ref="leaveForm"
              id="leaveForm"
              v-model.trim="formValid"
              lazy-validation
              v-on:submit.stop.prevent="CreateOrupdateLeave"
            >
              <div class="drawer-content px-1">
                <!-- Select Staff Field -->
                <div class="mb-4" v-if="!leaveCreate.id">
                  <label
                    class="font-size-13 font-weight-700 grey--text text--darken-2 mb-1 d-block required"
                    >Select Staff</label
                  >
                  <v-autocomplete
                    hide-details
                    dense
                    solo
                    flat
                    outlined
                    placeholder="Select Staff"
                    :items="userList"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    item-value="id"
                    item-text="full_name"
                    v-on:change="getCategoryOptions"
                    v-model.trim="leaveCreate.staff"
                    class="rounded-lg bg-white"
                    color="cyan"
                    :rules="[
                      validateRules.required(leaveCreate.staff, 'Select Staff'),
                    ]"
                  ></v-autocomplete>
                </div>

                <!-- Selected Staff Profile Card -->
                <template v-if="leaveCreate && leaveCreate.staff != null">
                  <v-card
                    flat
                    class="grey lighten-5 rounded-lg pa-3 mb-4 border"
                  >
                    <div class="d-flex align-center">
                      <v-avatar
                        size="64"
                        class="mr-3 border shadow-sm bg-white"
                      >
                        <img
                          v-if="userData.profile_logo"
                          :src="userData.profile_logo"
                        />
                        <v-icon v-else color="cyan darken-2" large
                          >mdi-account-circle</v-icon
                        >
                      </v-avatar>
                      <div class="flex-grow-1">
                        <div
                          class="d-flex align-center justify-space-between mb-1"
                        >
                          <span
                            class="font-weight-700 font-size-15 grey--text text--darken-3"
                          >
                            {{ userData.full_name || "Staff Member" }}
                          </span>
                          <v-chip
                            color="blue lighten-4"
                            text-color="blue darken-4 px-3"
                            small
                            class="font-weight-500 text-capitalize"
                            v-if="userData && userData.designation_text"
                          >
                            {{ userData.designation_text }}
                          </v-chip>
                        </div>
                        <div
                          class="font-size-12 grey--text text--darken-1 d-flex align-center flex-wrap gap-2"
                        >
                          <span
                            v-if="userData && userData.user_email"
                            class="mr-3 d-flex align-center"
                          >
                            <v-icon x-small color="grey" class="mr-1"
                              >mdi-email-outline</v-icon
                            >
                            {{ userData.user_email }}
                          </span>
                          <span
                            v-if="userData && userData.phone_number"
                            class="d-flex align-center"
                          >
                            <v-icon x-small color="grey" class="mr-1"
                              >mdi-phone-outline</v-icon
                            >
                            {{ userData.phone_number }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </template>

                <!-- Leave Type & Quota Allocation Table -->
                <div class="mb-4" v-if="leaveCreate.staff">
                  <div
                    class="font-size-13 font-weight-700 grey--text text--darken-2 mb-2 required"
                  >
                    Select Leave Type & Allocation
                  </div>
                  <v-card flat class="border rounded-lg overflow-hidden">
                    <div class="v-data-table theme--light">
                      <div
                        class="v-data-table__wrapper"
                        style="height: auto !important"
                      >
                        <table class="w-100">
                          <thead>
                            <tr class="grey lighten-4">
                              <th class="simple-table-th" style="width: 40px">
                                #
                              </th>
                              <th class="simple-table-th font-size-12">
                                Leave Type
                              </th>
                              <th class="simple-table-th font-size-12">
                                Remaining
                              </th>
                              <th class="simple-table-th font-size-12">
                                Pending
                              </th>
                              <th class="simple-table-th font-size-12">Used</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(row, index) in categoryList">
                              <tr
                                :key="index"
                                :class="[
                                  'customer-listing-row',
                                  leaveCreate.category === row.leave
                                    ? 'cyan lighten-5'
                                    : '',
                                ]"
                              >
                                <td class="text-center py-1 px-2 border-bottom">
                                  <v-radio-group
                                    v-model="leaveCreate.category"
                                    row
                                    :disabled="row.balance == 0"
                                    hide-details
                                    v-on:change="
                                      (event) => {
                                        calculateDate(
                                          leaveCreate,
                                          event,
                                          'category'
                                        );
                                        resetDate(row);
                                      }
                                    "
                                    class="ma-0 d-flex justify-center"
                                  >
                                    <v-radio
                                      label=""
                                      :value="row.leave"
                                      color="cyan"
                                      class="ma-0"
                                    ></v-radio>
                                  </v-radio-group>
                                </td>
                                <td
                                  class="py-1 px-3 font-weight-600 font-size-13 grey--text text--darken-3 border-bottom text-capitalize"
                                >
                                  {{ row.leave_title }}
                                </td>
                                <td
                                  class="text-center py-1 px-2 font-weight-700 font-size-13 cyan--text text--darken-3 border-bottom"
                                >
                                  {{ row.balance }}
                                </td>
                                <td
                                  class="text-center py-1 px-2 font-weight-600 font-size-13 amber--text text--darken-3 border-bottom"
                                >
                                  {{ row.pending }}
                                </td>
                                <td
                                  class="text-center py-1 px-2 font-weight-600 font-size-13 grey--text text--darken-2 border-bottom"
                                >
                                  {{ row.leave_used }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-card>
                </div>

                <!-- Date Range Selection -->
                <v-row dense class="mb-2">
                  <v-col cols="12" md="6" class="pb-2">
                    <label
                      class="font-size-13 font-weight-700 grey--text text--darken-2 mb-1 d-block required"
                      >Start Date</label
                    >
                    <DatePicker
                      solo
                      flat
                      outlined
                      :disabled="disabledDate"
                      :mandatory="true"
                      :nullable="
                        leaveCreate && leaveCreate.id > 0 ? false : true
                      "
                      placeholder="Start Date"
                      v-model="start_date"
                      :min-date="minDate"
                      :default-date="start_date"
                      :offWeekend="true"
                      v-on:change="
                        (event) => calculateDate(leaveCreate, event, 'start')
                      "
                      class="rounded-lg"
                    ></DatePicker>
                  </v-col>

                  <v-col cols="12" md="6" class="pb-2">
                    <label
                      class="font-size-13 font-weight-700 grey--text text--darken-2 mb-1 d-block required"
                      >End Date</label
                    >
                    <template
                      v-if="
                        leaveCreate && leaveCreate.id > 0 && end_date == null
                      "
                    >
                      <DatePicker
                        :mandatory="true"
                        :nullable="leaveCreate"
                        :disabled="disabledDate"
                        placeholder="End Date"
                        v-model="end_date"
                        :min-date="start_date"
                        :max-date="maxDate"
                        :default-date="end_date"
                        :offWeekend="true"
                        v-on:change="
                          (event) => calculateDate(leaveCreate, event, 'end')
                        "
                        class="rounded-lg"
                      ></DatePicker>
                    </template>
                    <template v-else>
                      <DatePicker
                        solo
                        :disabled="disabledDate"
                        flat
                        outlined
                        :nullable="
                          leaveCreate && leaveCreate.id > 0 ? false : true
                        "
                        placeholder="End Date"
                        v-model="end_date"
                        :min-date="start_date"
                        :max-date="maxDate"
                        :default-date="end_date"
                        v-on:change="
                          (event) => calculateDate(leaveCreate, event, 'end')
                        "
                        :mandatory="true"
                        offWeekend
                        class="rounded-lg"
                      >
                      </DatePicker>
                    </template>
                  </v-col>
                </v-row>

                <!-- Half Day Switch & Options Box -->
                <v-card flat class="grey lighten-5 rounded-lg pa-3 mb-3 border">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span
                      class="font-size-13 font-weight-700 grey--text text--darken-3"
                    >
                      Half Day
                    </span>
                    <v-switch
                      :disabled="diableDay"
                      v-model="leaveCreate.duration"
                      :value="leaveCreate.duration"
                      dense
                      hide-details
                      color="cyan"
                      class="ma-0"
                      v-on:change="changeData(leaveCreate.duration)"
                    ></v-switch>
                  </div>
                  <div
                    class="mt-2 pt-2 border-top"
                    v-if="leaveCreate.duration == 1"
                  >
                    <div class="d-flex flex-column">
                      <v-checkbox
                        v-model="leaveCreate.second_half_start_date"
                        :label="`Second half of Start Date : ${formatDate(
                          this.start_date
                        )}`"
                        :disabled="
                          (start_date === end_date &&
                            leaveCreate.first_half_of_end_date) ||
                          isWeekend(start_date)
                        "
                        color="cyan"
                        class="ma-0 mb-1"
                        hide-details
                        @change="updateHalfDaySelection(2, $event)"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="leaveCreate.first_half_of_end_date"
                        :label="`First half of End Date : ${formatDate(
                          this.end_date
                        )}`"
                        :disabled="
                          (start_date === end_date &&
                            leaveCreate.second_half_start_date) ||
                          isWeekend(end_date)
                        "
                        color="cyan"
                        class="ma-0"
                        hide-details
                        @change="updateHalfDaySelection(1, $event)"
                      ></v-checkbox>
                    </div>
                  </div>
                </v-card>

                <!-- Total Business Days Banner -->
                <v-sheet
                  class="cyan lighten-5 rounded-lg pa-3 d-flex align-center justify-space-between mb-4 border"
                >
                  <div class="d-flex align-center">
                    <v-icon color="cyan darken-2" class="mr-2" small
                      >mdi-clock-outline</v-icon
                    >
                    <span
                      class="font-size-13 font-weight-700 cyan--text text--darken-3"
                    >
                      Total Calculated Business Days
                    </span>
                  </div>
                  <v-chip
                    color="cyan darken-2"
                    class="white--text font-weight-800 px-3"
                    small
                  >
                    <template v-if="start_date && end_date">
                      {{ getBusinessDays() }} Day(s)
                    </template>
                    <template v-else>0 Days</template>
                  </v-chip>
                </v-sheet>

                <!-- Reason for Leave Textarea -->
                <div class="mb-4">
                  <label
                    class="font-size-13 font-weight-700 grey--text text--darken-2 mb-1 d-block required"
                    >Reason for Leave</label
                  >
                  <TextAreaField
                    auto-grow
                    dense
                    filled
                    color="cyan"
                    v-model.trim="leaveCreate.reason"
                    placeholder="Enter detailed reason for leave..."
                    solo
                    flat
                    row-height="25"
                    counter="200"
                  />
                </div>

                <!-- Attachment Upload Box -->
                <div class="mb-3">
                  <label
                    class="font-size-13 font-weight-700 grey--text text--darken-2 mb-1 d-block"
                    >Attachment (Medical certificate / document)</label
                  >
                  <FileUpload v-model="files"></FileUpload>
                </div>
              </div>
            </v-form>
          </perfect-scrollbar>
        </v-card-text>
        <v-card-actions class="d-flex px-4 py-3 border-top bg-white">
          <v-btn
            depressed
            outlined
            color="grey darken-1"
            class="custom-grey-border custom-bold-button rounded-lg text-capitalize"
            v-on:click="$emit('close')"
            >Cancel</v-btn
          >
          <v-btn
            depressed
            :disabled="!formValid || formLoading || pageLoading"
            :loading="formLoading"
            class="custom-bold-button white--text rounded-lg px-5 text-capitalize"
            color="cyan"
            v-on:click="CreateOrupdateLeave"
          >
            <v-icon small left>mdi-check</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <Dialog :common-dialog="statusDialog" :dialog-width="640">
      <template v-slot:title>
        <div class="d-flex">
          <div>Confirmed<br /></div>
        </div>
      </template>
      <template v-slot:body>
        <p class="btx-p m-0 text-align-center">
          <template v-for="(row, index) in visitArr">
            <span :key="index">
              <h3 class="font-size-16 font-weight-500 delete-text">
                <span
                  class="font-weight-700"
                  v-if="userData && userData.full_name"
                  >{{ userData.full_name }}</span
                >
                is already assigned to
                <span class="font-weight-700" color="red">{{
                  row.barcode
                }}</span>
                on
                <!-- {{ formatDate(row.started_at)}} -->
                {{ formatDate(row.started_at) }}
                {{ formatDateTimeStart(row.started_at) }} -
                {{ formatetimedata(row.finished_at) }}
              </h3>
            </span>
          </template>
        </p>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          style="min-width: 78px !important"
          v-on:click="continueData"
        >
          Continue
        </v-btn>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="statusDialog = false"
        >
          Cancel
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>
<style scoped>
/* .bt-table .v-data-table__wrapper {
    height: auto;
    overflow: auto;
} */
</style>
<script>
/* import MainMixin from "@/core/mixins/main.mixin.js"; */
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { POST, GET } from "@/core/services/store/request.module";
import moment from "moment-timezone";
import { SET_MESSAGE, SET_ERROR } from "@/core/services/store/common.module";
import { toSafeInteger, filter, find, toString } from "lodash";
import { getCurrentUser } from "@/core/services/jwt.service";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Dialog from "@/view/pages/partials/Dialog";
import FileUpload from "@/view/components/app-component/FileInput.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import { GET_LEAVE_STATUS } from "@/core/services/store/leave.module";

/* import { LeaveEventBus } from "@/core/lib/leave.form.lib"; */
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "CreateLeave",
  components: {
    DatePicker,
    FileUpload,
    Dialog,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    leaveUpdateData: {
      type: Object,
    },
    leaveIds: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formLoading: false,
      probisionTime: 0,
      excludesDates: [],
      formValid: true,
      minDate: new Date().toISOString().substr(0, 10),
      leave: null,
      updateDialog: false,
      apprveLeaves: 0,
      pendingLeaves: 0,
      statusDialog: false,
      allocated: 0,
      diableDay: false,
      pageLoading: false,
      userData: [],
      categoryList: new Array(),
      is_visit_validated: 1,
      visitArr: [],
      start_date: null,
      end_date: null,
      maxDate: null,
      weekEndDays: 0,
      userList: new Array(),
      remainingLeaves: null,
      holidays: [],
      files: [
        {
          file: null,
          name: null,
        },
      ],
      leaveList: [
        {
          category: null,
          maxdays: null,
          remainig_days: null,
        },
      ],
      leaveCreate: new Object({
        id: null,
        staff: null,
        category: "UnPaid",
        remainig_days: null,
        duration: 0,
        duration_type: 1,
        day_type: 2,
        first_half_of_end_date: false,
        second_half_start_date: false,
        reason: null,
      }),
    };
  },
  watch: {
    start_date() {
      this.categoryDays();
    },
    "leaveCreate.duration_type": {
      handler(param) {
        if (param == 1) {
          this.leaveCreate.day_type = 2;
        }
        if (param == 2) {
          this.leaveCreate.day_type = 1;
        }
      },
    },
    "leaveCreate.duration": {
      handler(param) {
        if (param == 0) {
          this.leaveCreate.first_half_of_end_date = 0;
          this.leaveCreate.second_half_start_date = 0;
        }
      },
    },
    "leaveCreate.staff": {
      handler(param) {
        this.init(param);
      },
    },
    // "leaveCreate.first_half_of_end_date && leaveCreate.second_half_start_date" : {
    //   handler(param) {
    //     if (!param) {
    //       this.leaveCreate.duration = 0;
    //     }

    //   },
    // },

    leaveUpdateData: {
      handler(param) {
        if (param) {
          this.init(param);
        }
      },
    },
  },
  methods: {
    isWeekend(date) {
      if (!date) return false;
      const day = moment(date).day();

      return day === 0 || day === 6;
    },
    continueData() {
      (this.is_visit_validated = 0), console.log(this.is_visit_validated);
      this.statusDialog = false;
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    formatetimedata(row) {
      return moment(row).format("hh:mm A");
    },
    calculateDate(data, e, type) {
      if (type == "category") {
        this.start_date = null;
        this.end_date = null;
        return false;
      }

      if (data.id == null && data.category != "UnPaid") {
        let firstDay = moment(this.start_date);
        let lastDay = moment(this.end_date);
        if (type == "start" && e) {
          firstDay = moment(e);
        } else {
          lastDay = moment(e);
        }

        if (firstDay && lastDay) {
          let calcBusinessDays =
            1 +
            (lastDay.diff(firstDay, "days") * 5 -
              (firstDay.day() - lastDay.day()) * 2) /
              7;
          if (lastDay.day() == 6) calcBusinessDays--; //SAT
          if (firstDay.day() == 0) calcBusinessDays--; //SUN

          // Count holidays between dates
          let currentDate = moment(firstDay);
          while (currentDate <= lastDay) {
            if (this.isHoliday(currentDate)) {
              calcBusinessDays--;
            }
            currentDate.add(1, "days");
          }

          if (this.leaveCreate.duration == 1) {
            calcBusinessDays = calcBusinessDays - 0.5;
          }

          this.totalDuration = calcBusinessDays;
          if (this.remainingLeaves < this.totalDuration) {
            this.leaveCreate.duration = 1;
            this.diableDay = true;
          } else {
            this.leaveCreate.duration = 0;
            this.diableDay = false;
          }
        }
      }
    },
    getColor(data) {
      if (data == 1) {
        return "blue";
      } else if (data == 2) {
        return "yellow";
      } else if (data == 3) {
        return "red";
      } else if (data == 4) {
        return "green";
      } else if (data == 5) {
        return "red";
      } else if (data == 6) {
        return "cyan";
      }
    },
    getBusinessDays() {
      if (!this.start_date || !this.end_date) return 0;

      var lastDay = moment(this.end_date);
      var firstDay = moment(this.start_date);

      // Count all calendar days, including Saturday, Sunday and holidays
      let calcBusinessDays = lastDay.diff(firstDay, "days") + 1;

      if (this.leaveCreate.duration == 1) {
        if (
          this.leaveCreate.first_half_of_end_date &&
          this.leaveCreate.second_half_start_date
        ) {
          calcBusinessDays = calcBusinessDays - 1;
        } else if (
          this.leaveCreate.first_half_of_end_date ||
          this.leaveCreate.second_half_start_date
        ) {
          calcBusinessDays = calcBusinessDays - 0.5;
        }
      }

      if (Number(calcBusinessDays) < 0) {
        calcBusinessDays = 0;
      }

      return calcBusinessDays;
    },
    // getBusinessDays() {
    //   if (!this.start_date || !this.end_date) return 0;

    //   var lastDay = moment(this.end_date);
    //   var firstDay = moment(this.start_date);
    //   let calcBusinessDays =
    //     1 +
    //     (lastDay.diff(firstDay, "days") * 5 -
    //       (firstDay.day() - lastDay.day()) * 2) /
    //       7;
    //   if (lastDay.day() == 6) calcBusinessDays--; //SAT
    //   if (firstDay.day() == 0) calcBusinessDays--; //SUN

    //   let currentDate = moment(firstDay);
    //   while (currentDate <= lastDay) {
    //     if (this.isHoliday(currentDate)) {
    //       calcBusinessDays--;
    //     }
    //     currentDate.add(1, "days");
    //   }

    //   if (this.leaveCreate.duration == 1) {
    //     if (
    //       this.leaveCreate.first_half_of_end_date &&
    //       this.leaveCreate.second_half_start_date
    //     ) {
    //       calcBusinessDays = calcBusinessDays - 1;
    //     } else if (
    //       this.leaveCreate.first_half_of_end_date ||
    //       this.leaveCreate.second_half_start_date
    //     ) {
    //       calcBusinessDays = calcBusinessDays - 0.5;
    //     }
    //   }

    //   if (Number(calcBusinessDays) < 0) {
    //     calcBusinessDays = 0;
    //   }

    //   return calcBusinessDays;
    // },
    updateTotalDays() {
      if (this.start_date === this.end_date) {
        if (
          this.leaveCreate.first_half_of_end_date &&
          this.leaveCreate.second_half_start_date
        ) {
          this.leaveCreate.first_half_of_end_date = false;
          this.leaveCreate.second_half_start_date = false;
        }
      }
      this.getBusinessDays();
    },
    updateHalfDaySelection(durationType, selected) {
      if (selected) {
        this.leaveCreate.duration_type = durationType;
      }
      this.updateTotalDays();
    },
    getProvision(proDate) {
      let a = moment();
      let b = moment(proDate);
      this.probisionTime = b.diff(a, "days");
    },
    changeData(data) {
      if (data == true) {
        this.leaveCreate.duration = 1;
      } else {
        this.leaveCreate.duration = 0;
      }
      if (this.start_date && this.end_date) {
        this.getBusinessDays();
      }
    },
    init(param) {
      if (param && param.id) {
        this.leaveCreate = {
          id: param.id,
          staff: (param.staff && param.staff.id) || null,
          category: (param.category && param.category) || null,
          duration: param.duration || 0,
          duration_type: toSafeInteger(param.duration_type) || 1,
          reason: param.reason || null,
          first_half_of_end_date: param.first_half_of_end_date || false,
          second_half_start_date: param.second_half_start_date || false,
          day_type: toSafeInteger(param.day_type) || 1,
        };
        this.start_date = param.start_date || null;
        this.end_date = param.end_date || null;
        if (this.leaveCreate.staff > 0) {
          // this.getUser(this.leaveCreate.staff);
          this.getCategoryOptions(this.leaveCreate.staff);
          /* this.categoryDays(); */
        }
      }
    },
    getMaxDate(mindate, remainig_days) {
      if (remainig_days <= 0) {
        return moment(mindate, "YYYY-MM-DD")
          .add(Math.floor(remainig_days) - 1, "days")
          .format("YYYY-MM-DD");
      }
      return null;
    },
    currentUserData() {
      const user = getCurrentUser();
      if (user && user.role != "Admin") {
        this.leaveCreate.staff = user.id;
      }
      return user;
    },

    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/options",
        })
        .then(({ data }) => {
          _this.userList = data.users;
          _this.holidays = data.holiday;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    categoryDays() {
      const _this = this;
      let categoryData = filter(_this.categoryList, function (row) {
        return row.leave == _this.leaveCreate.category;
      });

      if (categoryData[0] && categoryData[0].balance) {
        let maxDate = toString(
          moment(this.start_date, "YYYY-MM-DD")
            .add(
              Math.ceil(
                toSafeInteger(categoryData[0].balance) +
                  toSafeInteger(this.weekEndDays)
              ) - 1,
              "days"
            )
            .format("YYYY-MM-DD")
        );

        var lastDay = moment(maxDate);
        var firstDay = moment(this.start_date);
        let calcBusinessDays =
          1 +
          (lastDay.diff(firstDay, "days") * 5 -
            (firstDay.day() - lastDay.day()) * 2) /
            7;
        if (lastDay.day() == 6) calcBusinessDays--; //SAT
        if (firstDay.day() == 0) calcBusinessDays--; //SUN

        // Count holidays between dates
        let currentDate = moment(firstDay);
        while (currentDate <= lastDay) {
          if (this.isHoliday(currentDate)) {
            calcBusinessDays--;
          }
          currentDate.add(1, "days");
        }

        let addWeekends = categoryData[0].balance - calcBusinessDays;

        if (addWeekends > 0) {
          this.weekEndDays = this.weekEndDays + addWeekends;
          this.categoryDays();
        } else {
          this.weekEndDays = 0;
          this.maxDate = maxDate;
          this.remainingLeaves = categoryData[0].balance;
          this.apprveLeaves = categoryData[0].taken;
          this.pendingLeaves = categoryData[0].pending;
          this.allocated = categoryData[0].allocated_days;
        }
      }
    },
    getCategoryOptions(userList = 0) {
      if (userList == 0) {
        const user = getCurrentUser();
        if (user && user.role == "Staff") {
          userList = user.id;
        } else {
          return false;
        }
      }

      if (userList > 0) {
        const _this = this;
        _this.pageLoading = true;
        _this.categoryDays();
        _this.$store
          .dispatch(GET, {
            url: "setting/leave/option/" + userList,
          })
          .then((data) => {
            // _this.getUser(userList);
            _this.categoryList = data.data.categories;
            _this.userData = data.data;
            _this.categoryList.push({
              category: "UnPaid",
              leave_title: "UnPaid",
              leave: "UnPaid",
            });
            if (this.leaveCreate.id == null) {
              _this.categoryDays();
            }
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.pageLoading = false;
          });
      }
      /* 	this.categoryDays(); */
    },
    getUser(id) {
      this.$store
        .dispatch(GET, { url: `single-user/${id}` })
        .then((data) => {
          this.userData = data.data;
          this.getProvision(this.userData.provision_date);
        })
        .catch((error) => {
          console.log({ error });
        });
    },
    CreateOrupdateLeave() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs["leaveForm"]);
      _this.$refs["leaveForm"].validate();
      if (formErrors.length) {
        _this.errors = [];
        this.$store.commit(SET_ERROR, this.errors.concat(formErrors));
        return false;
      }
      if (!_this.$refs["leaveForm"].validate()) {
        return false;
      }
      _this.pageLoading = true;
      let leaveId = _this.leaveCreate.id || 0;
      let staff = _this.leaveCreate.staff || null;
      if (!staff) {
        const user = getCurrentUser();
        staff = user.id;
      }
      if (this.leaveCreate.duration == true) {
        this.leaveCreate.duration = 1;
      } else {
        this.leaveCreate.duration = 0;
      }
      let remainigBalanceData = find(this.categoryList, {
        // category: this.leaveCreate.category,
        leave: this.leaveCreate.category,
      });

      if (!this.leaveCreate.reason) {
        ErrorEventBus.$emit("update:error", "Leave Reason is required.");
        this.pageLoading = false;
        return false;
      }

      if (
        this.getBusinessDays() <= 0 &&
        this.leaveCreate.category != "UnPaid"
      ) {
        ErrorEventBus.$emit(
          "update:error",
          "You must select a valid start and end date for leave."
        );
        this.pageLoading = false;
        return false;
      }
      if (
        remainigBalanceData &&
        remainigBalanceData.balance < this.getBusinessDays() &&
        this.leaveCreate.category != "UnPaid"
      ) {
        ErrorEventBus.$emit(
          "update:error",
          " Sorry ! You don't have any leave balance for this leave type "
        );
        this.pageLoading = false;
        return false;
      }
      if (
        remainigBalanceData &&
        remainigBalanceData.balance == 0 &&
        this.leaveCreate.category != "UnPaid"
      ) {
        this.$store.commit(SET_ERROR, [
          {
            model: true,
            message:
              "Sorry ! You don't have any leave balance for this leave type",
          },
        ]);
        this.pageLoading = false;
        return false;
      }
      this.pageLoading = true;
      let formData = new FormData();
      formData.append(
        "staff",
        this.leaveCreate.staff ? this.leaveCreate.staff : 0
      );
      // console.log(this.validDates);

      // if (this.lodash.size(this.validDates[0]) > 0) {
      //   formData.append('valid_dates', JSON.stringify(this.validDates[0]));
      // }
      // if (this.lodash.size(this.validDates[1]) > 0) {
      //   formData.append('excluded_dates', JSON.stringify(this.validDates[1]));
      // }

      formData.append(
        "category",
        this.leaveCreate.category ? this.leaveCreate.category : null
      );
      /* formData.append("remaining", this.remainingLeaves ? this.remainingLeaves:0);
        console.log(this.remainingLeaves) */
      /*	formData.append("pending", this.pendingLeaves ? this.pendingLeaves:0);
        formData.append("allocated", this.allocated ? this.allocated:0); */
      formData.append(
        "duration",
        this.leaveCreate.duration ? this.leaveCreate.duration : 0
      );
      formData.append(
        "is_visit_validated",
        this.is_visit_validated && this.is_visit_validated == 1 ? 1 : 0
      );
      formData.append(
        "first_half_of_end_date",
        this.leaveCreate.first_half_of_end_date ? 1 : 0
      );
      formData.append(
        "second_half_start_date",
        this.leaveCreate.second_half_start_date ? 1 : 0
      );

      formData.append(
        "duration_type",
        this.leaveCreate.duration_type ? this.leaveCreate.duration_type : 1
      );
      formData.append("total_leave_days", this.getBusinessDays());
      if (this.leaveCreate && this.leaveCreate.reason) {
        formData.append(
          "reason",
          this.leaveCreate.reason ? this.leaveCreate.reason : null
        );
      }
      if (this.start_date) {
        formData.append("start_date", this.start_date ? this.start_date : null);
      }

      if (this.leaveCreate && this.leaveCreate.day_type) {
        formData.append(
          "day_type",
          this.leaveCreate.day_type ? this.leaveCreate.day_type : 1
        );
      }
      if (this.end_date) {
        formData.append("end_date", this.end_date ? this.end_date : null);
      }
      if (this.files && this.files.length) {
        for (let i = 0; i < this.files.length; i++) {
          if (this.files && this.files[i] && this.files[i].file) {
            formData.append(`file[${i}][file]`, this.files[i].file);
            formData.append(`file[${i}][name]`, this.files[i].name);
          }
        }
      }
      let requestTYPE = POST;
      let requestURL = "leave";

      if (leaveId > 0) {
        requestURL = `leave/${leaveId}`;
      }

      this.$store
        .dispatch(requestTYPE, {
          url: requestURL,
          data: formData,
        })
        .then((data) => {
          this.visitArr = data.data;
          if (
            this.visitArr &&
            this.visitArr.length > 0 &&
            this.is_visit_validated == 1
          ) {
            this.statusDialog = true;
            return false;
          }
          if (leaveId > 0) {
            this.$store.commit(SET_MESSAGE, [
              { model: true, message: "Success ! Leave updated successfully." },
              this.$emit("close"),
              LeaveApplyEventBus.$emit("refresh"),
              /* this.leaveCreate = {} */
            ]);
          } else {
            this.$store.commit(SET_MESSAGE, [
              { model: true, message: "Success ! Leave added successfully." },
              this.$emit("close"),
            ]);
          }
          /* 	LeaveEventBus.$emit("refresh", true); */
          LeaveApplyEventBus.$emit("refresh"), this.$emit("refresh-data", true);
          this.$store.dispatch(GET_LEAVE_STATUS, {});
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    resetDate(row) {
      if (row.balance == 0 && row.category != "UnPaid") {
        this.blankdate = true;
      } else {
        this.blankdate = false;
      }
    },
    isHoliday(date) {
      if (!date) return false;
      const dateStr = moment(date).format("YYYY-MM-DD");
      return this.holidays.includes(dateStr);
    },
  },
  created() {
    if (this.leaveCreate.staff > 0) {
      this.getCategoryOptions();
    }
  },

  mounted() {
    const _this = this;
    _this.getOptions();
    /* _this.categoryDays(); */

    _this.getProvision(this.userData.provision_date);
    _this.init(this.leaveUpdateData);
    _this.leave = toSafeInteger(_this.$route.params.id);
  },

  computed: {
    validDates() {
      if (!this.start_date || !this.end_date) return [];

      const validDates = [];
      const excludesDatess = [];
      let currentDate = moment(this.start_date);
      const endDate = moment(this.end_date);

      while (currentDate <= endDate) {
        if (!this.isHoliday(currentDate) && !this.isWeekend(currentDate)) {
          validDates.push(currentDate.format("YYYY-MM-DD"));
        } else {
          excludesDatess.push(currentDate.format("YYYY-MM-DD"));
        }
        currentDate.add(1, "days");
      }

      return [validDates, excludesDatess];
    },
    is_staff() {
      const user = this.currentUserData();
      const role_name = user.role;
      return role_name != "Admin";
    },
    disabledDate() {
      let catData = find(
        this.categoryList,
        (row) => row.leave == this.leaveCreate.category
      );

      if (
        (catData && catData.balance > 0) ||
        this.leaveCreate.category == "UnPaid"
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>
